import { render } from "./WindowShadow.vue?vue&type=template&id=3530874c&scoped=true"
import script from "./WindowShadow.vue?vue&type=script&lang=js"
export * from "./WindowShadow.vue?vue&type=script&lang=js"

import "./WindowShadow.vue?vue&type=style&index=0&id=3530874c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3530874c"]])

export default __exports__